import React, { useEffect, useRef, useState } from 'react';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import Paid from './Paid';
import ConfirmRequest from './ConfirmRequest';
import Posted from './Posted';
import Delivered from './Delivered';
import Canceled from './Canceled';
import { Link } from 'react-router-dom';


const Index = () => {

    const [currentTab, setCurrentTab] = useState('paid');

    const searchData = () => {

    }

    return (
        <div className="card">

            <div className="card-header">
                <div className="card-title" style={{width:"100%"}}>
                    لیست سفارشات به تفکیک وضعیت
                    <div className="card-title  d-flex justify-content-between">
                        <p className='text-muted'>
                            لیست سفارشات مربوط به امروز است در صورت مشاهده ی سفارشات روزهای گذشته بر روی منوی
                            <Link to="service-consumer" className='btn btn-light mx-4'>
                                <i class="fa  px-1 fe fe-dollar-sign"></i>
                                فروش</Link>

                            کلیک فرمایید.
                        </p>
                        <button className="btn btn-dark mx-2 accordion-toggle collapsed  d-none d-sm-block" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseFour" aria-expanded="false">جستجو</button>
                    </div>
                </div>
            </div>

            <div className="card-body panel-group1" id="accordion1">
                <div id="collapseFour" className="panel-collapse collapse position-relative" role="tabpanel" aria-expanded="false">
                    
                </div>
            </div>

            <div className="card-body">

                <div className="row mb-5">
                    <div className="col-md-2 d-grid mb-1">
                        <button onClick={e => setCurrentTab('paid')} className={currentTab == 'paid' ? 'btn btn-info' : 'btn btn-info-light'}>پرداخت شده</button>
                    </div>
                    <div className="col-md-2 d-grid mb-1">
                        <button onClick={e => setCurrentTab('confirmRequest')} className={currentTab == 'confirmRequest' ? 'btn btn-info' : 'btn btn-info-light'}>  تایید درخواست  </button>
                    </div>
                    <div className="col-md-2 d-grid mb-1">
                        <button onClick={e => setCurrentTab('posted')} className={currentTab == 'posted' ? 'btn btn-info' : 'btn btn-info-light'}>    ارسال شده </button>
                    </div>
                    <div className="col-md-2 d-grid mb-1">
                        <button onClick={e => setCurrentTab('delivered')} className={currentTab == 'delivered' ? 'btn btn-info' : 'btn btn-info-light'}> تحویل شده </button>
                    </div>
                    <div className="col-md-2 d-grid mb-1">
                        <button onClick={e => setCurrentTab('canceled')} className={currentTab == 'canceled' ? 'btn btn-info' : 'btn btn-info-light'}>  لغو شده </button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        {currentTab == 'paid' ? <Paid /> : ''}
                        {currentTab == 'confirmRequest' ? <ConfirmRequest /> : ''}
                        {currentTab == 'posted' ? <Posted /> : ''}
                        {currentTab == 'delivered' ? <Delivered /> : ''}
                        {currentTab == 'canceled' ? <Canceled /> : ''}
                    </div>
                </div>

            </div>

        </div>
    )
}

export default Index;
